import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, API } from "../contexts/AuthContext";
import { Eye, EyeOff, BookOpen } from "lucide-react";
import axios from "axios";

const IMG = "https://images.unsplash.com/photo-1771665375888-4cfab92dbac4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZSUyMG1vZGVybiUyMGJ1aWxkaW5nJTIwY2xlYW58ZW58MHx8fHwxNzc4MDQ1NjU1fDA&ixlib=rb-4.1.0&q=85";

export default function RegisterPage() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [dosenList, setDosenList] = useState([]);
  const [form, setForm] = useState({
    name: "", email: "", password: "", role: "mahasiswa",
    nim: "", nip: "", whatsapp: "", judul_ta: "", pembimbing1_id: "", pembimbing2_id: "",
  });
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      if (user.role === "admin") navigate("/admin");
      else if (user.role === "dosen") navigate("/dosen");
      else navigate("/mahasiswa");
    }
  }, [user, navigate]);

  useEffect(() => {
    axios.get(`${API}/users/dosen`, { withCredentials: true })
      .then(r => setDosenList(r.data))
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.role === "mahasiswa" && (!form.nim || !form.judul_ta || !form.pembimbing1_id || !form.pembimbing2_id)) {
      setError("Lengkapi semua data mahasiswa (NIM, Judul TA, dan kedua pembimbing)");
      return;
    }
    if (form.role === "dosen" && !form.nip) {
      setError("NIP wajib diisi untuk dosen");
      return;
    }
    if (form.pembimbing1_id && form.pembimbing1_id === form.pembimbing2_id) {
      setError("Pembimbing 1 dan Pembimbing 2 tidak boleh sama");
      return;
    }
    setLoading(true);
    try {
      await register(form);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const f = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  return (
    <div className="min-h-screen flex bg-[#FDFDFD] font-[Manrope]">
      {/* Left Panel 
      <div className="hidden lg:flex lg:w-2/5 relative overflow-hidden">
        <img src={IMG} alt="Architecture" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#002147]/75" />
        <div className="absolute inset-0 flex flex-col justify-end p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-white rounded-sm flex items-center justify-center">
              <BookOpen size={22} className="text-[#002147]" />
            </div>
            <span className="text-white font-bold text-xl font-[Outfit]">Monitoring TA</span>
          </div>
          <h2 className="text-white font-bold text-3xl font-[Outfit] leading-tight mb-3">
            Bergabung &<br />Mulai Monitoring
          </h2>
          <p className="text-white/70 text-sm leading-relaxed">
            Daftar sebagai mahasiswa atau dosen pembimbing untuk memulai monitoring tugas akhir.
          </p>
        </div>
      </div> */}

      {/* Right Panel */}
      <div className="flex-1 flex items-center justify-center px-6 py-8">
        <div className="w-full max-w-lg bg-white border border-slate-200 rounded-lg shadow-sm p-8">
          <div className="mb-6">
            {/* <div className="flex items-center gap-2 lg:hidden mb-4">
              <div className="w-8 h-8 bg-[#002147] rounded-sm flex items-center justify-center">
                <BookOpen size={16} className="text-white" />
              </div>
              <span className="font-bold text-[#002147] font-[Outfit]">Monitoring TA</span>
            </div> */}
            <h1 className="text-3xl font-bold text-[#0F172A] font-[Outfit] mb-1">Buat Akun</h1>
            <p className="text-[#475569] text-sm">Lengkapi data untuk mendaftar</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Role */}
            <div>
              <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Daftar Sebagai</label>
              <div className="flex gap-2">
                {["mahasiswa", "dosen"].map(r => (
                  <button
                    key={r}
                    type="button"
                    data-testid={`role-${r}`}
                    onClick={() => setForm(p => ({ ...p, role: r }))}
                    className={`flex-1 py-2.5 rounded-sm text-sm font-semibold border transition-all duration-200 ${
                      form.role === r
                        ? "bg-[#002147] text-white border-[#002147]"
                        : "bg-white text-[#475569] border-slate-200 hover:border-[#002147] hover:text-[#002147]"
                    }`}
                  >
                    {r === "mahasiswa" ? "Mahasiswa" : "Dosen Pembimbing"}
                  </button>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Nama Lengkap</label>
                <input data-testid="reg-name" required type="text" value={form.name} onChange={f("name")}
                  placeholder="Nama lengkap"
                  className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all" />
              </div>

              <div className="col-span-2">
                <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Email</label>
                <input data-testid="reg-email" required type="email" value={form.email} onChange={f("email")}
                  placeholder="email@universitas.ac.id"
                  className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all" />
              </div>

              <div className="col-span-2">
                <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Password</label>
                <div className="relative">
                  <input data-testid="reg-password" required type={showPass ? "text" : "password"} value={form.password} onChange={f("password")}
                    placeholder="Minimal 6 karakter"
                    className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all pr-10" />
                  <button type="button" onClick={() => setShowPass(!showPass)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#475569] hover:text-[#0F172A]">
                    {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>

              <div className="col-span-2">
                <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Nomor WhatsApp</label>
                <input data-testid="reg-whatsapp" type="tel" value={form.whatsapp} onChange={f("whatsapp")}
                  placeholder="cth: 081234567890"
                  className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all" />
              </div>

              {form.role === "mahasiswa" && (
                <>
                  <div>
                    <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">NIM</label>
                    <input data-testid="reg-nim" type="text" value={form.nim} onChange={f("nim")}
                      placeholder="NIM"
                      className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all" />
                  </div>

                  <div className="col-span-2">
                    <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Judul Tugas Akhir</label>
                    <input data-testid="reg-judul" type="text" value={form.judul_ta} onChange={f("judul_ta")}
                      placeholder="Judul TA Anda"
                      className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all" />
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Pembimbing 1</label>
                    <select data-testid="reg-pembimbing1" value={form.pembimbing1_id} onChange={f("pembimbing1_id")}
                      className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all bg-white">
                      <option value="">Pilih Pembimbing 1</option>
                      {dosenList.filter(d => d.id !== form.pembimbing2_id).map(d => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">Pembimbing 2</label>
                    <select data-testid="reg-pembimbing2" value={form.pembimbing2_id} onChange={f("pembimbing2_id")}
                      className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all bg-white">
                      <option value="">Pilih Pembimbing 2</option>
                      {dosenList.filter(d => d.id !== form.pembimbing1_id).map(d => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {form.role === "dosen" && (
                <div className="col-span-2">
                  <label className="block text-xs font-bold text-[#0F172A] uppercase tracking-widest mb-2">NIP</label>
                  <input data-testid="reg-nip" type="text" value={form.nip} onChange={f("nip")}
                    placeholder="NIP"
                    className="w-full border border-slate-200 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-[#002147] focus:ring-1 focus:ring-[#002147] transition-all" />
                </div>
              )}
            </div>

            {error && (
              <div data-testid="register-error" className="bg-red-50 border border-red-200 rounded-sm px-4 py-3 text-sm text-red-600">
                {error}
              </div>
            )}

            <button
              data-testid="register-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#002147] hover:bg-[#001833] disabled:bg-slate-400 text-white py-3 rounded-sm font-semibold text-sm transition-all duration-200 active:translate-y-px"
            >
              {loading ? "Mendaftar..." : "Daftar Sekarang"}
            </button>
          </form>

          <p className="text-center text-sm text-[#475569] mt-4">
            Sudah punya akun?{" "}
            <Link to="/login" className="text-[#002147] font-semibold hover:underline" data-testid="login-link">
              Masuk di sini
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
